export function formatNumber(number) {
  if (Number.isInteger(number)) return number;
  return number.toFixed(0);
}
